import moment from "moment";

export const convertToJsonKeepLocalDate = (json: object) => {
    Date.prototype.toJSON = function () { return moment(this).format(); }
    return JSON.stringify(json);
}